/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/

(function() {
  function initMarquee() {
    if (window.innerWidth <= 767) return;
    document.querySelectorAll('#FeaturedCollection--template--18475710283910__section_collection_9xqiax .featured-collection__container').forEach(function(container) {
      if (container.dataset.marqueeInit) return;
      container.dataset.marqueeInit = 'true';
      var slider = container.querySelector('.carousel');
      if (!slider) return;
      var slides = Array.from(slider.querySelectorAll('[data-slide]'));
      if (!slides.length) return;
      var marquee = document.createElement('div');
      marquee.style.cssText = 'display:flex; overflow:hidden; width:100%;';
      var track = document.createElement('div');
      track.style.cssText = 'display:flex; animation: featured-marquee 50s linear infinite; will-change: transform;';
      [1, 2].forEach(function() {
        slides.forEach(function(slide) {
          var item = document.createElement('div');
          item.style.cssText = 'flex-shrink:0; width:25vw; padding-right:2px;';
          item.innerHTML = slide.innerHTML;
          track.appendChild(item);
        });
      });
      marquee.appendChild(track);
      slider.parentNode.replaceChild(marquee, slider);
      if (!document.getElementById('featured-marquee-style')) {
        var style = document.createElement('style');
        style.id = 'featured-marquee-style';
        style.innerHTML = '@keyframes featured-marquee { 0% { transform: translateX(0); } 100% { transform: translateX(-50%); } }';
        document.head.appendChild(style);
      }
    });
  }

  // Wait for Flickity to finish, then swap
  document.addEventListener('DOMContentLoaded', function() {
    var target = document.querySelector('#FeaturedCollection--template--18475710283910__section_collection_9xqiax .carousel');
    if (!target) return;
    var observer = new MutationObserver(function(mutations, obs) {
      if (target.classList.contains('flickity-enabled')) {
        obs.disconnect();
        setTimeout(initMarquee, 100);
      }
    });
    observer.observe(target, { attributes: true, attributeFilter: ['class'] });
    // Fallback in case Flickity already initialized
    if (target.classList.contains('flickity-enabled')) {
      setTimeout(initMarquee, 100);
    }
  });
})();




/*
 * UMAI: round the "Sale • Save X%" badge UP (34.31% -> 35%).
 * The theme's bundled JS fills [data-price-off-amount] with Math.round;
 * this recomputes from the real variant prices with Math.ceil and
 * overwrites the badge whenever the theme touches it.
 */
(function() {
  document.addEventListener('DOMContentLoaded', function() {
    var jsonEl = document.querySelector('[data-product-json]');
    if (!jsonEl) return;
    var product;
    try { product = JSON.parse(jsonEl.textContent); } catch (e) { return; }

    function fix() {
      var sel = document.querySelector('[data-product-select]');
      var id = sel ? parseInt(sel.value, 10) : null;
      var v = (product.variants || []).filter(function(x) { return x.id === id; })[0] || product.variants[0];
      if (!v || !v.compare_at_price || v.compare_at_price <= v.price) return;
      var pct = Math.ceil((v.compare_at_price - v.price) / v.compare_at_price * 100) + '%';
      document.querySelectorAll('[data-price-off-amount]').forEach(function(el) {
        if (el.textContent.trim() !== pct) el.textContent = pct; /* guard prevents observer loop */
      });
    }

    var obs = new MutationObserver(fix);
    document.querySelectorAll('[data-price-off-amount]').forEach(function(el) {
      obs.observe(el, { childList: true, characterData: true, subtree: true });
    });
    document.addEventListener('variant:changed', function() { setTimeout(fix, 50); });
    fix();
  });
})();